// ============================================================
// หน้า Customer — รายชื่อลูกค้า (ผู้อยู่อาศัยในโครงการ)
// ------------------------------------------------------------
// สิ่งที่ทำได้ในหน้านี้
//   - ค้นหา/แสดงรายชื่อลูกค้าแบบแบ่งหน้า พร้อมสรุปจำนวนตามสถานะการโอน
//   - เพิ่ม / แก้ไข / ลบ ลูกค้า และ "เปลี่ยนสัญญาเช่าซื้อ" (แก้ไขแบบบันทึกสาเหตุ ref_cause = 2)
//   - นำเข้าข้อมูลลูกค้าจากไฟล์ Excel (ตรวจหัวคอลัมน์ก่อน แล้วให้ดูตัวอย่างก่อนกดนำเข้า)
//   - ออกรายงาน 4 แบบ และส่งออกข้อมูลลูกค้าเป็น Excel
//
// สิทธิ์: อ่านจากเมนู "customer" — ไม่มีสิทธิ์ view จะไม่โหลดข้อมูลเลย
// ============================================================

import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import Switch from "react-switch";
import { ReactExcel, readFile, generateObjects } from "@ramonak/react-excel";
import { DownloadTableExcel } from "react-export-table-to-excel";

import "../../shared/config/global.js";
import "../../assets/css/bootstrap.css";
import Navbar from "../../shared/layout/Navbar";
import excel_file from "../../assets/files/import_customer.xlsx";
import {
  tokens,
  select_style,
  alert,
  alert_2,
  GET,
  POST,
  PUT,
  DELETE,
  format_date,
  validate,
  getStorage,
  loading,
  permission,
  DatePicker,
  TextField,
  DateField,
  SelectField,
  ActionIcon,
  Paginate,
  ExcelDropZone,
  ICON,
} from "../../shared/index.js";
import { CUSTOMER_SHEET_NAME, CUSTOMER_COLUMNS, TRANSFER_FROM_TEXT, BUY_FROM_TEXT, findInvalidColumn, padLeftDigits } from "../../shared/domain/customer-excel.js";
import { report_customer_0 } from "../../documents/builders/ReportCustomer00.js";
import { report_customer_1 } from "../../documents/builders/ReportCustomer01.js";
import { report_customer_2 } from "../../documents/builders/ReportCustomer02.js";
import { report_customer_3 } from "../../documents/builders/ReportCustomer03.js";

// สิทธิ์ของผู้ใช้ในเมนูนี้ (อ่านครั้งเดียวตอนโหลดไฟล์)
const perm = permission("customer");

// ---------- ตัวเลือก / ค่าคงที่ ----------

// สถานะการโอนกรรมสิทธิ์ (ค่าเดียวกับที่ backend เก็บ)
const TRANSFER_OPTS = [
  { value: 1, label: "โอนกรรมสิทธิ์แล้ว" },
  { value: 2, label: "ยังไม่โอนกรรมสิทธิ์" },
  { value: 3, label: "ห้องว่าง" },
];

// วิธีการซื้ออาคาร
const BUY_OPTS = [
  { value: 1, label: "เงินสด" },
  { value: 2, label: "ผ่อนชำระกับธนาคาร" },
  { value: 3, label: "ผู้เช่าซื้อกับการเคหะแห่งชาติ" },
  { value: 4, label: "ซื้อต่อกับลูกค้าเดิม" },
  { value: 5, label: "อื่น ๆ" },
  { value: 6, label: "การเคหะแห่งชาติ" },
];

// สีป้ายสถานะในตาราง
const TRANSFER_COLOR = { 1: "bg-primary", 2: "bg-purple", 3: "bg-blue" };

// หัวคอลัมน์ตารางแสดงตัวอย่างก่อนนำเข้า
const PREVIEW_HEADERS = [
  "ชื่อ - สกุล",
  "เลขบัตรประชาชน",
  "ที่อยู่",
  "โทรศัพท์บ้าน",
  "โทรศัพท์มือถือ",
  "วันที่ส่งมอบ",
  "วันที่มารับมอบ",
  "วันที่โอน",
  "สถานะการโอน",
  "เลขที่เงินกู้",
  "วงเงินกู้",
  "เงินงวด",
  "วันที่ทำสัญญา",
  "ซื้ออาคารโดย",
  "อาคาร",
  "ชั้น",
  "บ้านเลขที่",
  "ขนาดห้อง (ตรม.)",
  "ลบ",
];

// รายงานทั้ง 4 แบบ — status_transfer ที่ส่งไปกรองข้อมูล + ฟังก์ชันสร้าง PDF
const REPORTS = [
  { label: "รายงานลูกค้าทั้งหมด", status: "", render: (d) => report_customer_0(d) },
  { label: "รายงานลูกค้าโอนกรรมสิทธิ์", status: 1, render: (d) => report_customer_1(d) },
  { label: "รายงานลูกค้ายังไม่โอน", status: 2, render: (d, s) => report_customer_2(d, s.common_expenses, s.common_expenses_type) },
  { label: "รายงานห้องว่าง", status: 3, render: (d, s) => report_customer_3(d, s.common_expenses, s.equipment_maintenance_fee, s.common_expenses_type) },
];

// ---------- ตัวช่วยเล็ก ๆ ----------

// หา option จากค่าที่เก็บใน DB (ใช้เติมค่าลง react-select)
const getOpt = (opts, val) => opts.find((o) => o.value === val) || "";
// หาข้อความจากค่าที่เก็บใน DB
const getLabel = (opts, val) => opts.find((o) => o.value === val)?.label || "-";
// วันที่สำหรับไฟล์ Excel (ค.ศ. รูปแบบ yyyy-mm-dd)
const fDate = (d) => (d ? format_date(d, "yyyy-mm-dd", "en") : "");
// ช่องว่างในตารางตัวอย่างนำเข้า จะไฮไลต์แดงถ้าไม่มีค่า
const tdCls = (val) => (val ? "text-left" : "text-left bg-danger-light");

// ค่าเริ่มต้นของฟอร์มลูกค้า
const EMPTY_FORM = {
  full_name: "",
  id_card: "",
  address: "",
  home_phone: "",
  mobile_phone: "",
  delivery_date: "",
  receive_date: "",
  transfer_date: "",
  status_transfer: "",
  loan_number: "",
  credit_limit: "",
  installment: "",
  contract_date: "",
  status_buy_building: "",
  address_number: "",
  building: "",
  floor: "",
  room_size: "",
  ref_cause: 0,
};

export default class Customer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // popup
      modal_create: false,
      modal_update: false,
      modal_change: false,
      modal_import: false,
      // ตัวกรอง + หน้าที่แสดง
      page: 1,
      filter_data_search: "",
      filter_transfer_date: "",
      filter_status_transfer: null,
      // ข้อมูล
      data: null, // ข้อมูลหน้าปัจจุบัน (แบ่งหน้า)
      all: null, // ข้อมูลทั้งหมด ใช้กับตารางส่งออก Excel
      // นำเข้าไฟล์
      import: null, // ไฟล์ที่อ่านเข้ามา (ให้ ReactExcel แปลง)
      currentSheet: null, // ชีตที่ ReactExcel แปลงเสร็จแล้ว
      data_import: null, // รายการที่เตรียมนำเข้า (แสดงในตารางตัวอย่าง)
      // ฟอร์ม
      customer_id: "",
      status_cable: false,
      ...EMPTY_FORM,
      // ค่าจากตั้งค่าโครงการ ใช้ในรายงาน
      common_expenses: 0,
      common_expenses_type: 0, // 0 = เหมาต่อห้อง | 1 = คิดตามขนาดห้อง (ตร.ม.)
      equipment_maintenance_fee: 0,
      // ตัวเลขสรุปหัวตาราง
      transfer_count: 0,
      not_transfer_count: 0,
      blank_room_count: 0,
    };
    this.tableRefAll = React.createRef();
  }

  async componentDidMount() {
    if (!perm.view) return;
    loading(true);
    await this.GetSetting();
    await this.GetAll();
    loading(false);
    this.GetSummary();
  }

  // ---------- เรียกข้อมูล ----------

  // เงื่อนไขการค้นหาที่ส่งไป backend (ใช้ร่วมกันทั้งตาราง สรุปยอด และรายงาน)
  getApiBody = () => ({
    data_search: this.state.filter_data_search,
    transfer_date: this.state.filter_transfer_date,
    status_transfer: this.state.filter_status_transfer?.value || "",
  });

  // ข้อมูลลูกค้าของหน้าปัจจุบัน
  GetAll = async () => {
    loading(true);
    const result = await GET(tokens, `v1/TH/customer-manage/filter-search/page/${this.state.page}/${getStorage("project_id")}`, this.getApiBody());
    if (result?.status) this.setState({ data: result.data });
    loading(false);
  };

  // ข้อมูลทั้งหมด (page 0) — ใช้นับยอดสรุปตามสถานะ และเป็นแหล่งข้อมูลของตารางส่งออก Excel
  GetSummary = async () => {
    const result_all = await GET(tokens, `v1/TH/customer-manage/filter-search/page/0/${getStorage("project_id")}`, this.getApiBody());
    if (!result_all?.data?.data) return;
    const d = result_all.data.data;
    this.setState({
      transfer_count: d.filter((e) => e.status_transfer === 1).length,
      not_transfer_count: d.filter((e) => e.status_transfer === 2).length,
      blank_room_count: d.filter((e) => e.status_transfer === 3).length,
      all: d,
    });
  };

  // ตั้งค่าโครงการ (ค่าส่วนกลาง/ค่าบริการอุปกรณ์ ใช้ในรายงาน)
  // ถ้ายังไม่ได้ตั้งวันปิดรับชำระ/วันตัดมิเตอร์ จะเตือนแล้วพาไปหน้าตั้งค่าอัตราค่าน้ำ
  GetSetting = async () => {
    const result = await GET(tokens, "v1/TH/water-manage/detail/" + getStorage("water_id"), null);
    if (!result?.status) return;
    const data = result.data.data;
    if (!data?.payment_close_time || !data?.meter_cut_date) {
      alert_2("/manage-water", "warning", "แจ้งเตือน", "ท่านยังไม่ทำการตั้งค่าวันที่ปิดรับชำระเงินและวันที่ตัดมิเตอร์ก่อนทำการเริ่มต้นใช้งานระบบ");
    }
    this.setState({ common_expenses: data?.common_expenses, equipment_maintenance_fee: data?.equipment_maintenance_fee, common_expenses_type: data?.common_expenses_type });
  };

  // ออกรายงาน — ดึงข้อมูลทั้งหมดตามสถานะที่รายงานนั้นต้องการ แล้วส่งให้ตัวสร้าง PDF
  GetReportData = async (report) => {
    loading(true);
    const body = { ...this.getApiBody(), status_transfer: report.status };
    const result = await GET(tokens, "v1/TH/customer-manage/filter-search/page/0/" + getStorage("project_id"), body);
    if (result?.status) report.render(result.data.data, this.state);
    loading(false);
  };

  // ---------- บันทึก / ลบ ----------

  // แปลงค่าในฟอร์มเป็นรูปที่ backend รับ (ใช้ทั้งตอนเพิ่มและแก้ไข)
  buildPayload = () => {
    const s = this.state;
    return {
      full_name: s.full_name,
      id_card: s.id_card,
      address: s.address,
      home_phone: s.home_phone,
      mobile_phone: s.mobile_phone,
      // วันที่ว่างต้องส่ง null ไม่ใช่สตริงว่าง
      delivery_date: s.delivery_date || null,
      receive_date: s.receive_date || null,
      transfer_date: s.transfer_date || null,
      status_transfer: s.status_transfer?.value || 0,
      loan_number: s.loan_number,
      credit_limit: Number(s.credit_limit),
      installment: Number(s.installment),
      contract_date: s.contract_date || null,
      status_buy_building: s.status_buy_building?.value || 0,
      address_number: s.address_number,
      building: Number(s.building),
      floor: Number(s.floor),
      room_size: Number(s.room_size),
      status_cable: s.status_cable,
    };
  };

  // เพิ่ม (modal_create) หรือแก้ไข/เปลี่ยนสัญญา (modal_update, modal_change)
  CreateUpdate = async () => {
    if (validate(this.state, ["full_name", "building", "floor", "address_number"])) return;
    loading(true);

    const is_create = this.state.modal_create;
    const payload = this.buildPayload();
    const result = is_create
      ? await POST(tokens, "v1/TH/customer-manage/create/" + getStorage("project_id"), { customer_list: [payload] })
      : await PUT(tokens, "v1/TH/customer-manage/update", { ...payload, customer_id: this.state.customer_id, ref_cause: Number(this.state.ref_cause) });

    if (result?.status) alert_2("/customer", "success", "สำเร็จ", is_create ? "เพิ่มข้อมูลลูกค้าสำเร็จแล้ว" : "แก้ไขข้อมูลลูกค้าสำเร็จแล้ว");
    loading(false);
  };

  // นำเข้ารายการทั้งหมดที่เตรียมไว้ในตารางตัวอย่าง
  CreateImport = async () => {
    loading(true);
    const result = await POST(tokens, "v1/TH/customer-manage/create/" + getStorage("project_id"), { customer_list: this.state.data_import });
    if (result?.status) alert_2("/customer", "success", "สำเร็จ", "เพิ่มข้อมูลลูกค้าสำเร็จแล้ว");
    loading(false);
  };

  Delete = async (customer_id) => {
    const confirmed = await alert_2("", "info", "ยืนยันการลบข้อมูลลูกค้า", "ท่านแน่ใจว่าต้องการลบข้อมูลหรือไม่? หลังจากท่านยืนยันการยกเลิกแล้วจะไม่สามารถย้อนคืนข้อมูลได้", "ยืนยัน", "ยกเลิก");
    if (!confirmed) return;
    loading(true);
    const result = await DELETE(tokens, "v1/TH/customer-manage/delete/" + customer_id, null);
    if (result?.status) alert_2("/customer", "success", "สำเร็จ", "ลบข้อมูลลูกค้าสำเร็จแล้ว");
    loading(false);
  };

  // ---------- ฟอร์ม ----------

  // ล้างฟอร์มและตัวกรองทั้งหมด (เรียกก่อนเปิด popup เพิ่ม/นำเข้า)
  clear_form = () => {
    this.setState({
      modal_create: false,
      modal_update: false,
      modal_change: false,
      modal_import: false,
      page: 1,
      filter_data_search: "",
      filter_transfer_date: "",
      filter_status_transfer: null,
      import: null,
      currentSheet: null,
      data_import: null,
      ...EMPTY_FORM,
    });
  };

  // เปิด popup แก้ไข (type = "update") หรือเปลี่ยนสัญญา (type = "change")
  // เปลี่ยนสัญญาจะบันทึก ref_cause = 2 เพื่อให้ backend รู้ว่าเป็นการเปลี่ยนผู้ถือสัญญา
  openModal = (item, type) => {
    this.setState({
      modal_update: type === "update",
      modal_change: type === "change",
      customer_id: item.customer_id,
      full_name: item.full_name,
      id_card: item.id_card,
      address: item.address,
      home_phone: item.home_phone,
      mobile_phone: item.mobile_phone,
      delivery_date: item.delivery_date,
      receive_date: item.receive_date,
      transfer_date: item.transfer_date,
      status_transfer: getOpt(TRANSFER_OPTS, item.status_transfer),
      loan_number: item.loan_number,
      credit_limit: item.credit_limit,
      installment: item.installment,
      contract_date: item.contract_date,
      status_buy_building: getOpt(BUY_OPTS, item.status_buy_building),
      address_number: item.address_number,
      building: item.building,
      floor: item.floor,
      room_size: item.room_size,
      ref_cause: type === "change" ? 2 : 0,
      status_cable: item.status_cable,
    });
  };

  closeFormModal = () => this.setState({ modal_create: false, modal_update: false, modal_change: false });

  // ---------- นำเข้าไฟล์ Excel ----------

  // อ่านไฟล์ (ได้ทั้งจากลากวางและเลือกไฟล์) แล้วให้ ReactExcel แปลงเป็นชีต
  // ต้องรอ 10ms ให้ ReactExcel อัปเดต currentSheet ก่อนถึงจะอ่านข้อมูลได้
  readExcel = (file) => {
    readFile(file)
      .then((data) => {
        this.setState({ import: data });
        setTimeout(this.Import, 10);
      })
      .catch(console.error);
  };

  // ตรวจหัวคอลัมน์ + แปลงข้อมูลในชีตเป็นรายการลูกค้า
  Import = () => {
    const invalidColumn = findInvalidColumn(this.state.currentSheet[CUSTOMER_SHEET_NAME][0]);
    if (invalidColumn) {
      alert("warning", "แจ้งเตือน", `หัวคอลัมน์ "${invalidColumn}" ไม่ถูกต้อง`);
      loading(false);
      return;
    }

    const data = generateObjects(this.state.currentSheet)
      .filter((item) => item["ชื่อ - สกุล"])
      .map((item) => ({
        full_name: item["ชื่อ - สกุล"],
        // เลขบัตร/เบอร์มือถือใน Excel มักถูกตัดเลข 0 นำหน้าทิ้ง — เติมกลับให้ครบหลัก
        id_card: padLeftDigits(item["เลขบัตรประชาชน"], 13),
        address: item["ที่อยู่"],
        home_phone: (item["โทรศัพท์บ้าน"] || "").toString(),
        mobile_phone: padLeftDigits(item["โทรศัพท์มือถือ"], 10),
        delivery_date: item["วันที่ส่งมอบ"] || null,
        receive_date: item["วันที่มารับมอบ"] || null,
        transfer_date: item["วันที่โอน"] || null,
        status_transfer: TRANSFER_FROM_TEXT[item["สถานะการโอน"]] || 0,
        loan_number: (item["เลขที่เงินกู้"] || "").toString(),
        credit_limit: item["วงเงินกู้"] || 0,
        installment: item["เงินงวด"] || 0,
        contract_date: item["วันที่ทำสัญญา"] || null,
        status_buy_building: BUY_FROM_TEXT[item["ซื้ออาคารโดย"]] || 0,
        address_number: (item["บ้านเลขที่"] || "").toString(),
        building: item["อาคาร"],
        floor: item["ชั้น"],
        room_size: item["ขนาดห้อง (ตรม.)"],
        status_cable: false,
      }));

    data.splice(0, 1); // แถวแรกคือแถวตัวอย่างในไฟล์ template ไม่ต้องนำเข้า
    this.setState({ data_import: data });
  };

  // ลบ 1 แถวออกจากตารางตัวอย่างก่อนนำเข้า (ลบหมดแล้วกลับไปหน้าเลือกไฟล์)
  removeImportRow = (index) => {
    const data = [...this.state.data_import];
    data.splice(index, 1);
    this.setState({ data_import: data.length ? data : null });
  };

  // ---------- ส่วนแสดงผล ----------

  render() {
    const { state } = this;

    return (
      <div className="w-100 min-vh-100 fade-in">
        <Navbar page1="หน้าหลัก" page2="รายชื่อลูกค้า" />
        <div className="body">
          <div className="p-3">
            <div className="card border-0 p-3">
              {/* หัวข้อ + ปุ่มรายงาน/นำเข้า/ส่งออก/เพิ่ม */}
              <div className="d-flex row mx-0 align-items-center justify-content-between test">
                <h4 className="mb-3">
                  <b>รายชื่อลูกค้า</b>
                </h4>
                <div className="d-flex row mx-0">
                  {perm.view && (
                    <div className="d-flex flex-wrap px-0">
                      {REPORTS.map((report, i) => (
                        <button key={i} className="btn btn-outline-primary mx-1 mb-3 text-nowarp" onClick={() => this.GetReportData(report)}>
                          {report.label}
                        </button>
                      ))}
                    </div>
                  )}
                  {perm.create && (
                    <div className="d-flex flex-wrap px-0">
                      {/* ส่งออก Excel — ดึงจากตารางที่ซ่อนไว้ด้านล่าง */}
                      <DownloadTableExcel filename="ข้อมูลลูกค้า" sheet="ข้อมูลลูกค้า" currentTableRef={this.tableRefAll.current}>
                        <button className="btn btn-blue px-4 mx-1 text-light mb-3 text-nowrap">ส่งออกข้อมูลลูกค้า</button>
                      </DownloadTableExcel>
                      <button
                        className="btn btn-blue px-4 mx-1 text-light mb-3 text-nowrap"
                        onClick={() => {
                          this.clear_form();
                          this.setState({ modal_import: true });
                        }}
                      >
                        นำเข้าข้อมูลลูกค้า
                      </button>
                      <button
                        className="btn btn-primary px-4 mx-1 mb-3 text-nowrap"
                        onClick={() => {
                          this.clear_form();
                          this.setState({ modal_create: true });
                        }}
                      >
                        เพิ่มข้อมูลลูกค้า
                      </button>
                    </div>
                  )}
                </div>
              </div>

              {/* ตัวกรอง */}
              {perm.view && (
                <div className="d-flex row mx-0 align-items-center justify-content-between">
                  <div className="d-flex row mx-0">
                    <input
                      type="search"
                      className="form-control wpx-200 bg-contain border-0 mx-1 mb-3"
                      placeholder="ชื่อลูกค้า บ้านเลขที่..."
                      value={state.filter_data_search}
                      onChange={(e) => this.setState({ filter_data_search: e.target.value })}
                    />
                    <div className="wpx-200 mx-1 mb-3 px-0">
                      <DatePicker className="form-control bg-contain border-0" placeholder="พิมพ์คำค้นหา..." value={state.filter_transfer_date} onChange={(e) => this.setState({ filter_transfer_date: e })} />
                    </div>
                    <div className="wpx-200 mx-1 mb-3 px-0">
                      <Select
                        className="form-control bg-contain border-0 select-search"
                        styles={select_style}
                        options={TRANSFER_OPTS}
                        value={state.filter_status_transfer}
                        isClearable
                        onChange={(e) => this.setState({ filter_status_transfer: e })}
                      />
                    </div>
                    <button className="btn btn-primary px-3 mb-3 mx-1" onClick={() => this.setState({ page: 1 }, this.GetAll)}>
                      ค้นหา
                    </button>
                    <button
                      className="btn btn-outline-primary px-3 mb-3 mx-1"
                      onClick={() => this.setState({ filter_data_search: "", filter_transfer_date: "", filter_status_transfer: "", page: 1 }, this.GetAll)}
                    >
                      รีเซ็ท
                    </button>
                  </div>
                </div>
              )}

              {/* ตารางรายชื่อลูกค้า */}
              <div className="table-responsive">
                {/* สรุปจำนวนตามสถานะ */}
                {/* flex-wrap + จับคู่ป้าย/ตัวเลข ให้จอแคบ (มือถือ) ขึ้นบรรทัดใหม่แทนการถูกตัด */}
                <div className="d-flex flex-wrap mb-3" style={{ rowGap: 4 }}>
                  <div className="d-flex">
                    <b className="text-nowrap">หน่วยก่อสร้าง : </b>
                    <span className="pl-2 pr-5 text-left">{state.data?.count || 0}</span>
                  </div>
                  <div className="d-flex">
                    <b className="text-nowrap">โอนกรรมสิทธิ์แล้ว : </b>
                    <span className="pl-2 pr-5 text-left">{state.transfer_count}</span>
                  </div>
                  <div className="d-flex">
                    <b className="text-nowrap">ยังไม่โอน : </b>
                    <span className="pl-2 pr-5 text-left">{state.not_transfer_count}</span>
                  </div>
                  <div className="d-flex">
                    <b className="text-nowrap">ห้องว่าง : </b>
                    <span className="pl-2 pr-5 text-left">{state.blank_room_count}</span>
                  </div>
                </div>

                <table className="table table-borderless table-striped">
                  <thead>
                    <tr className="bg-dark-blue text-white">
                      <th className="text-nowrap text-left">อาคาร</th>
                      <th className="text-nowrap text-left">ชั้นที่</th>
                      <th className="text-nowrap text-left">บ้านเลขที่</th>
                      <th className="text-nowrap text-left">ชื่อ - นามสกุล</th>
                      <th className="text-nowrap text-center wpx-150">สถานะ</th>
                      <th className="text-nowrap text-left">วันที่โอน</th>
                      <th className="text-nowrap text-left">โทรศัพท์</th>
                      <th className="text-nowrap text-left">โทรศัพท์มือถือ</th>
                      <th className="text-nowrap text-left">เปลี่ยนสัญญา</th>
                      {(perm.update || perm.delete) && <th className="text-nowrap text-center">จัดการ</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {!state.data?.data?.length ? (
                      <tr>
                        <td colSpan={9} className="text-center">
                          ไม่มีข้อมูล
                        </td>
                      </tr>
                    ) : (
                      state.data.data.map((item, i) => (
                        <tr key={i}>
                          <td>{item.building || "-"}</td>
                          <td>{item.floor || "-"}</td>
                          <td>{item.address_number || "-"}</td>
                          <td className="text-nowrap">{item.full_name || "-"}</td>
                          <td className="text-center">
                            <span className={`rounded px-2 py-1 text-white ${TRANSFER_COLOR[item.status_transfer] || "bg-blue"}`}>{getLabel(TRANSFER_OPTS, item.status_transfer)}</span>
                          </td>
                          <td>{item.transfer_date ? format_date(item.transfer_date) : "-"}</td>
                          <td>{item.home_phone || "-"}</td>
                          <td>{item.mobile_phone || "-"}</td>
                          <td className="text-center">{perm.update && <ActionIcon color="success" icon={ICON.change} title="เปลี่ยนสัญญา" onClick={() => this.openModal(item, "change")} />}</td>
                          {(perm.update || perm.delete) && (
                            <td className="text-center">
                              <div className="d-flex">
                                {perm.update && <ActionIcon color="primary" icon={ICON.edit} title="แก้ไข" className="mr-2" onClick={() => this.openModal(item, "update")} />}
                                {perm.delete && <ActionIcon color="danger" icon={ICON.delete} title="ลบ" onClick={() => this.Delete(item.customer_id)} />}
                              </div>
                            </td>
                          )}
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              <Paginate data={state.data} page={state.page} onChange={(v) => this.setState({ page: v }, this.GetAll)} />

              {/* ตารางซ่อน — เป็นแหล่งข้อมูลของปุ่มส่งออก Excel เท่านั้น ไม่ได้แสดงบนหน้าจอ */}
              <div style={{ height: 0, opacity: 0, overflow: "hidden" }}>
                <table className="table table-bordered table-hover mb-0" ref={this.tableRefAll}>
                  <thead>
                    <tr>
                      {CUSTOMER_COLUMNS.map((h) => (
                        <th key={h}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {state.all?.map((item, i) => (
                      <tr key={i}>
                        <td>{item.full_name || ""}</td>
                        <td>{item.id_card || ""}</td>
                        <td>{item.address || ""}</td>
                        <td>{item.home_phone || ""}</td>
                        <td>{item.mobile_phone || ""}</td>
                        {/* วันที่ทุกชุดออก 2 คอลัมน์ (ช่องกรอก + ค่าที่แสดง) ตามรูปแบบไฟล์ template */}
                        <td>{fDate(item.delivery_date)}</td>
                        <td>{fDate(item.delivery_date)}</td>
                        <td>{fDate(item.receive_date)}</td>
                        <td>{fDate(item.receive_date)}</td>
                        <td>{fDate(item.transfer_date)}</td>
                        <td>{fDate(item.transfer_date)}</td>
                        <td>{getLabel(TRANSFER_OPTS, item.status_transfer) === "-" ? "" : getLabel(TRANSFER_OPTS, item.status_transfer)}</td>
                        <td>{item.loan_number}</td>
                        <td>{item.credit_limit}</td>
                        <td>{item.installment}</td>
                        <td>{fDate(item.contract_date)}</td>
                        <td>{fDate(item.contract_date)}</td>
                        <td>{getLabel(BUY_OPTS, item.status_buy_building) === "-" ? "" : getLabel(BUY_OPTS, item.status_buy_building)}</td>
                        <td>{item.building}</td>
                        <td>{item.floor}</td>
                        <td>{item.address_number}</td>
                        <td>{item.room_size}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        {/* popup เพิ่ม / แก้ไข / เปลี่ยนสัญญา (ใช้ฟอร์มเดียวกัน ต่างกันที่หัวข้อและฟิลด์ที่แก้ไม่ได้) */}
        <Modal show={state.modal_create || state.modal_update || state.modal_change} onHide={this.closeFormModal} dialogClassName="modal-w">
          <Modal.Header>
            <Modal.Title>
              <b>{state.modal_create ? "เพิ่มข้อมูลลูกค้า" : state.modal_change ? "เปลี่ยนสัญญาเช่าซื้อ" : "แก้ไขข้อมูลลูกค้า"}</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              {/* คอลัมน์ซ้าย — ข้อมูลผู้อยู่อาศัย */}
              <div className="col-12 col-lg-6">
                <TextField label="ชื่อ-นามสกุล" req value={state.full_name} onChange={(v) => this.setState({ full_name: v })} />
                <TextField label="เลขบัตรประชาชน" numeric maxLength={13} value={state.id_card} onChange={(v) => this.setState({ id_card: v })} />
                <TextField label="ที่อยู่" value={state.address} onChange={(v) => this.setState({ address: v })} />
                <TextField label="ขนาดห้อง (ตรม.)" decimal maxLength={13} value={state.room_size} onChange={(v) => this.setState({ room_size: v })} />
                <TextField label="โทรศัพท์บ้าน" numeric maxLength={10} className="form-control border-0 bg-contain " value={state.home_phone} onChange={(v) => this.setState({ home_phone: v })} />
                <TextField label="โทรศัพท์มือถือ" numeric maxLength={10} value={state.mobile_phone} onChange={(v) => this.setState({ mobile_phone: v })} />
                <DateField label="วันที่ส่งมอบ" value={state.delivery_date} onChange={(v) => this.setState({ delivery_date: v })} />
                <DateField label="วันที่มารับมอบ" value={state.receive_date} onChange={(v) => this.setState({ receive_date: v })} />
                <DateField label="วันที่โอน" value={state.transfer_date} onChange={(v) => this.setState({ transfer_date: v })} />
                <div className="w-100 d-flex align-items-center mb-3">
                  <label className="wpx-140">เก็บค่าเคเบิล :</label>
                  <Switch onChange={(e) => this.setState({ status_cable: e })} checked={state.status_cable} />
                </div>
              </div>

              {/* คอลัมน์ขวา — ข้อมูลสัญญาและห้อง (อาคาร/ชั้น/บ้านเลขที่ แก้ไม่ได้ตอนแก้ไขข้อมูล) */}
              <div className="col-12 col-lg-6">
                <SelectField label="สถานะการโอน" options={TRANSFER_OPTS} value={state.status_transfer} onChange={(v) => this.setState({ status_transfer: v })} />
                <TextField label="เลขที่เงินกู้" numeric className="form-control border-0 bg-contain " value={state.loan_number} onChange={(v) => this.setState({ loan_number: v })} />
                <TextField label="วงเงินกู้" decimal className="form-control border-0 bg-contain " value={state.credit_limit} onChange={(v) => this.setState({ credit_limit: v })} />
                <TextField label="เงินงวด" decimal className="form-control border-0 bg-contain " value={state.installment} onChange={(v) => this.setState({ installment: v })} />
                <DateField label="วันที่ทำสัญญา" value={state.contract_date} onChange={(v) => this.setState({ contract_date: v })} />
                <SelectField label="ซื้ออาคารโดย" options={BUY_OPTS} value={state.status_buy_building} onChange={(v) => this.setState({ status_buy_building: v })} />
                <TextField label="อาคาร" req decimal readOnly={state.modal_update} className="form-control border-0 bg-contain " value={state.building} onChange={(v) => this.setState({ building: v })} />
                <TextField label="ชั้น" req decimal readOnly={state.modal_update} className="form-control border-0 bg-contain " value={state.floor} onChange={(v) => this.setState({ floor: v })} />
                <TextField label="บ้านเลขที่" req readOnly={state.modal_update} className="form-control border-0 bg-contain " value={state.address_number} onChange={(v) => this.setState({ address_number: v })} />
              </div>
            </div>

            <div className="w-100 d-flex">
              <div className="w-50 p-1">
                <button className="btn btn-outline-primary w-100" onClick={this.closeFormModal}>
                  ยกเลิก
                </button>
              </div>
              <div className="w-50 p-1">
                <button className="btn btn-primary w-100" onClick={this.CreateUpdate}>
                  {state.modal_create ? "เพิ่ม" : "บันทึก"}
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/* popup นำเข้าข้อมูลลูกค้าจาก Excel */}
        <Modal show={state.modal_import} onHide={() => this.setState({ modal_import: false })} dialogClassName="modal-w100">
          <Modal.Header>
            <Modal.Title>
              <b>นำเข้าข้อมูลลูกค้า</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* ยังไม่ได้เลือกไฟล์ → แสดงกล่องลากวาง */}
            {!state.data_import && <ExcelDropZone templateFile={excel_file} templateName="import_customer.xlsx" templateLabel="template นำเข้าข้อมูลลูกค้า" onFile={this.readExcel} />}

            {/* ตัวแปลงไฟล์ Excel ของ library — ซ่อนไว้ ไม่ได้ให้ผู้ใช้เห็น */}
            <div className="d-none">
              <ReactExcel initialData={state.import} onSheetUpdate={(s) => this.setState({ currentSheet: s })} activeSheetClassName="d-none" reactExcelClassName="table table-borderless table-striped" />
            </div>

            {/* ตารางตัวอย่างก่อนนำเข้า — ช่องที่ไม่มีค่าจะขึ้นพื้นแดง */}
            {state.data_import && (
              <div className="table-responsive" style={{ height: "80vh", maxHeight: "80vh" }}>
                <table className="table table-borderless table-striped">
                  <thead>
                    <tr className="bg-dark-blue text-white">
                      {PREVIEW_HEADERS.map((h) => (
                        <th key={h} className="text-left">
                          {h}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {state.data_import.map((item, index) => (
                      <tr key={index}>
                        <td className={tdCls(item.full_name)}>{item.full_name || "-"}</td>
                        <td className={tdCls(item.id_card)}>{item.id_card || "-"}</td>
                        <td className={tdCls(item.address)}>{item.address || "-"}</td>
                        <td className="text-left">{item.home_phone || "-"}</td>
                        <td className={tdCls(item.mobile_phone)}>{item.mobile_phone || "-"}</td>
                        <td className="text-left">{item.delivery_date || "-"}</td>
                        <td className="text-left">{item.receive_date || "-"}</td>
                        <td className="text-left">{item.transfer_date || "-"}</td>
                        <td className={tdCls(item.status_transfer)}>{getLabel(TRANSFER_OPTS, item.status_transfer)}</td>
                        <td className="text-left">{item.loan_number || "-"}</td>
                        <td className="text-left">{item.credit_limit || "-"}</td>
                        <td className="text-left">{item.installment || "-"}</td>
                        <td className="text-left">{item.contract_date || "-"}</td>
                        <td className={tdCls(item.status_buy_building)}>{getLabel(BUY_OPTS, item.status_buy_building)}</td>
                        <td className={tdCls(item.address_number)}>{item.address_number || "-"}</td>
                        <td className={tdCls(item.building)}>{item.building || "-"}</td>
                        <td className={tdCls(item.floor)}>{item.floor || "-"}</td>
                        <td className={tdCls(item.room_size)}>{item.room_size || "-"}</td>
                        <td>
                          <ActionIcon color="danger" icon={ICON.delete} title="ลบแถวนี้" onClick={() => this.removeImportRow(index)} />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {/* ปุ่มท้าย popup — ยังไม่มีข้อมูลมีแค่ปุ่มปิด, มีข้อมูลแล้วมี 3 ปุ่ม */}
            <div className="w-100 d-flex mt-2">
              {!state.data_import ? (
                <button className="btn btn-outline-primary w-100" onClick={() => this.setState({ modal_import: false })}>
                  ปิดหน้าต่าง
                </button>
              ) : (
                <>
                  <div className="p-1" style={{ width: "33%" }}>
                    <button className="btn btn-outline-primary w-100" onClick={() => this.setState({ modal_import: false })}>
                      ยกเลิก
                    </button>
                  </div>
                  <div className="p-1" style={{ width: "33%" }}>
                    <button className="btn btn-danger w-100" onClick={() => this.setState({ data_import: null })}>
                      ล้างค่า
                    </button>
                  </div>
                  <div className="p-1" style={{ width: "33%" }}>
                    <button className="btn btn-primary w-100" onClick={this.CreateImport}>
                      นำเข้า
                    </button>
                  </div>
                </>
              )}
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
